import axiosInstanceClient from "../Common/Axios/axiosInstanceClient";
import API from "../Common/Endpoint/serviceConstrants";
export const callDealCouponGetApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.get(API.dealCoupon, {
    params: {
      customerSegmentIds: payload?.customerSegmentId,
    },
    headers: {
      Login: payload.login,
    },
  });
  return data;
};

export const callDealCouponSourcesApi = async (payload) => {
  let request = {};
  if (payload?.columnName) {
    request.columnName = payload?.columnName;
  }
  if (payload?.withActiveOffer) {
    request.withActiveOffer = payload?.withActiveOffer;
  }
  const { data = [] } = await axiosInstanceClient.get(API.dealCouponSources, {
    params: request
  });
  return data;
};

